/**
 *
 * @class FontWeight
 *
 * how heavy a font is
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export enum FontWeight {
  NORMAL  = '',
  BOLD    = 'bold',
  BOLDER  = 'bolder',
  LIGHTER = 'lighter',
  _100    = '100',
  _200    = '200',
  _300    = '300',
  _400    = '400',
  _500    = '500',
  _600    = '600',
  _700    = '700',
  _800    = '800',
  _900    = '900'
}
